import { render, staticRenderFns } from "./ProductWithdrawalRequestTables.vue?vue&type=template&id=cf62f69e&"
import script from "./ProductWithdrawalRequestTables.vue?vue&type=script&lang=js&"
export * from "./ProductWithdrawalRequestTables.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports